import * as React from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import PropTypes from 'prop-types';
import reactHtmlParser from 'react-html-parser';
import ObjectIcon from '../../shared/ObjectIcon';
import { PopOutIcon } from '../../shared/PopOutIcon';
import { SearchContext } from './SearchContainer';
import * as CalendarActions from '../../../actions/calendar';
import { sanitizeString } from '../../../utils/stringUtils';
import { Tooltip } from '../../shared/Tooltip';
import '../SearchTableItem.scss';


const makeBold = (field, keyword) => {
  if (!keyword || keyword === '' || !field || field === '' || typeof field !== 'string') {
    return field;
  }

  // For clarity sanitize the keyword before the RegExp lookup.
  const sanitizedKeyword = sanitizeString(keyword);
  return (
    field?.replace(new RegExp('(' + sanitizedKeyword + ')', 'gi'), '<b>$1</b>')
  );
};

export const SearchTableItem = ({ item, isSelectedRecord }) => {
  if (!item) {
    return (
      <div className={'searchTableItem'}>
        <div className="searchTableItem-empty "><i>
            No search results found, please refine your search</i>
        </div>
      </div>
    );
  }

  const context = React.useContext(SearchContext);
  const dispatch = useDispatch();
  const relatedToApiName = useSelector((state) => state.calendar.selectedRecord?.type);
  const type = relatedToApiName || item.type || context.searchObject?.apiName;
  const user = useSelector((state) => state.auth.user);
  const recordLink = `${user.salesforceInstanceUrl}/lightning/r/${type}/${item.Id}/view`;
  const objectsAndDisplayFields = useSelector((state) => state.mail.settings?.objectsAndDisplayFields);
  const currentDisplayFields = objectsAndDisplayFields?.find((object) => object.apiName === type)?.displayFields.map((field) => field.apiName) || [];

  const selectRecord = async () => {
    /* if in compose, force a save here. This is needed to handle the scenario where
     * a user has opened the add-in, and then begins filling out the email. We are not
     * listening to subject updates at this point, so forcing a save here will give us
     * a head start on saving before the save button is pushed.
     */

    // TODO: Revisit this once we start on pre-saving
    // if (isDraftEvent && isDesktop()) {
    //   await officeApi.saveEmail();
    // }
    batch(() => {
      dispatch(CalendarActions.selectRecord({ ...item, type }));
      dispatch(CalendarActions.isSelectingRecord(false));
    });
  };


  const [itemClassName, onItemClick] = ['searchTableItem searchTableItem-highlight', selectRecord];

  return (
    <div className={itemClassName} onClick={onItemClick}>
      <ObjectIcon className={'searchTableItem-itemImage'} objectApiName={type} />
      <div className="searchTableItem-detailsContainer" >
        <Tooltip textContent={`${item[currentDisplayFields[0]] || ''}`}>
          <div className="searchTableItem-itemName">{reactHtmlParser(makeBold(item[currentDisplayFields[0]] || '', context.searchQuery))}</div>
        </Tooltip>
        {currentDisplayFields.length > 1 && currentDisplayFields.slice(1).map((displayField) => {
          return (
            <Tooltip key={`${displayField}-${item[displayField]}`} textContent={`${reactHtmlParser(item[displayField], context.searchQuery)}`}>
              <div className="searchTableItem-details">
                {reactHtmlParser(makeBold(item[displayField], context.searchQuery))}
              </div>
            </Tooltip>
          );
        })}
      </div>
      <PopOutIcon link={recordLink}/>
    </div>
  );
};

SearchTableItem.propTypes = {
  item: PropTypes.object,
  isSelectedRecord: PropTypes.bool,
};
